import { CONSENT_STYLES, type ConsentStyle } from 'config/onboardingV4/flows';
import { useMultivariateFlag } from './useMultivariateFlag';

/** Where onboarding v4 asks consent to AI: `screen` or `chat`. */
export const ONBOARDING_CONSENT_FLAG = 'onboarding-ai-consent';

/** Where a new onboarding v4 session asks consent; on a screen unless the flag says the chat. */
export const useOnboardingConsentStyle = () =>
  useMultivariateFlag<ConsentStyle, ConsentStyle>(
    ONBOARDING_CONSENT_FLAG,
    CONSENT_STYLES,
    'screen',
  );
